import { lazy } from '@loadable/component';
import type { ComponentType } from 'react';
import React, { Suspense } from 'react';
import LoadingBox from '../LoadingBox';

interface Props {
  loader(): Promise<{ default: ComponentType<unknown> }>;
  loading?: ComponentType;
}

const Loadable = ({ loader, loading }: Props) => {
  const LazyComponent = lazy(loader);

  const Load = loading || LoadingBox;

  return React.memo(() => (
    <Suspense fallback={<Load>Loading...</Load>}>
      {/* @ts-ignore */}
      <LazyComponent />
    </Suspense>
  ));
};

export default Loadable;
